export function getAttr(attr, attr_one, attr_two, attr_three,res) {
    attr.forEach((ib) => {
        ib.attr_name = ib.attr_name
            .replace(/[\r\n]/g, "")
            .replace(/\ +/g, ""); // 过滤空格、换行
        ib.attr_value = ib.attr_value
            ? ib.attr_value
                .replace(/[\r\n]/g, "")
                .replace(/\ +/g, "")
            : ""; // 过滤空格、换行
        if (ib.attr_mean <= 3) {
            // 右边重要卖点分离
            attr_one.push(ib);
        }
        if (ib.attr_mean > 3) {
            // 下面参数分离
            attr_three.push(ib);
        }
        if (
            ib.attr_name == "产品尺寸" ||
            ib.attr_name == "热水输出功率" ||
            ib.attr_name == "软水流量" ||
            ib.attr_name == "尺寸" ||
            ib.attr_name == "净水流量" ||
            ib.attr_name == "流量" ||
            ib.attr_name == "供冷量" ||
            ib.attr_name == "供热量" ||
            ib.attr_name == "制热量" ||
            ib.attr_name == "制冷量" ||
            ib.attr_name == "中控尺寸" ||
            (ib.attr_name == "长*宽*高(mm）"&&res.new_goods_type_id != 201) ||
            ib.attr_name == "风量" ||
            ib.attr_name == "热回收率" ||
            ib.attr_name == "开孔尺寸" ||
            ib.attr_name == "最大风量" ||
            ib.attr_name == "最大风压" ||
            ib.attr_name == "主机尺寸"
        ) {
            // 下面参数分离
            attr_two.push(ib);
        }
    });
}

//商品去重
export function noRepeat(arr, type = "shopp") {
    for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].goods_name == arr[j].goods_name && type == "shopp") {
                arr[i].num = arr[i].num + arr[j].num;
                arr.splice(j, 1);
                j--;
            }else if(type == "room" && arr[i].room == arr[j].room){
                arr.splice(j, 1);
                j--;
            }
        }
    }
    return arr;
}